$(document).ready(function() {
  var winW = $(window).width();

  const observer = lozad(); // lazy loads elements with default selector as '.lozad'
  observer.observe();

  // Header
  var barraH = $('.barra').outerHeight();
  var infoH = $('.infobar').outerHeight();
  var headerH = $('header').outerHeight();

  $(window).load(function() {
    var barraH = $('.barra').outerHeight();
    var infoH = $('.infobar').outerHeight();
    var headerH = $('header').outerHeight();
    if ( winW > 830 ) {
      $('body').css('padding-top', headerH + infoH);
      $('header').css('top', infoH);
      $(window).scroll(function() {
        if ($(window).scrollTop() > infoH) {
          $('header').addClass('fix');
          $('header').css('top', 0);
        } else {
          $('header').removeClass('fix');
          $('header').css('top', infoH);
        }
      });
    } else {
      $('body').css('padding-top', headerH + infoH );
      $('header').css('top', infoH);

      $(window).scroll(function() {
        if ($(window).scrollTop() > infoH) {
          $('header').addClass('fix');
          $('header').css('top', 0);
        } else {
          $('header').removeClass('fix');
          $('header').css('top', infoH);
        }
      });
    }
  });

  $('header .icons li .search').click(function() {
    $('header .big-search').toggleClass('show');
    $('header .black-search').toggleClass('show');
  });

  $('header .big-search .cerrar-big-search').click(function() {
    $('header .big-search').toggleClass('show');
    $('header .black-search').toggleClass('show');
  });

  $('header .icons li .cart').click(function() {
    $('#minicart').addClass('show');
    console.log('click')
  });

  $('header .cart').click(function() {
    $('#minicart').addClass('show');
  });

  $('#minicart .cerrar').click(function() {
    $('#minicart').removeClass('show');
  });

  $('header .show-menu').click(function() {
    $('nav').addClass('show');
  });

  $('header nav .cerrar').click(function() {
    $('nav').removeClass('show');
  });

  $('.barra .cerrar').click(function(){
    $('.barra').fadeOut(200);
    if ( winW > 830 ) {
      $('body').css('padding-top', headerH - infoH - barraH );
    } else {
      $('body').css('padding-top', headerH -  barraH  );
    }
  });

  // Product
  $('#main-photo ul').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    fade: true,
    adaptiveHeight: true
  });

  $('#mini-photos ul').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    vertical: false,
    asNavFor: '#main-photo ul',
    dots: false,
    arrows: false,
    centerMode: false,
    focusOnSelect: false,
    responsive: [
      {
        breakpoint: 830,
        settings: {
          vertical: false,
        }
      }
    ]
  });

  $('#mini-photos ul .slick-slide').on('click', function (event) {
    $('#main-photo ul').slick('slickGoTo', $(this).data('slickIndex'));
  });

  $('.product .deon > h3').each(function() {
    $(this).addClass('accor');
    $(this).nextUntil('h3').wrapAll('<div class="hide-info"></div>')
  });

  $('.product .deon h3').click(function() {
    $(this).toggleClass('active');
    $(this).next('.hide-info').toggleClass('show');
  });

  $('.product .deon h3.accor:nth-child(1)').click();

  $('.pro-int .contactar').click(function() {
    $('.pro-int .form').addClass('show');
  });

  $('.pro-int .form .cerrar').click(function() {
    $('.pro-int .form').removeClass('show');
  });

  // Shop The Look
  
  $('.pro-shop #gallery ul').slick({
    //infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    centerMode: true
  });

  $('.featured-collection ul .item[data-id="5980345401509"]').remove();
  $('.featured-collection ul .item[data-id="5980346384549"]').remove();
  $('.featured-collection ul .item[data-id="5980347859109"]').remove();

  $('.template-collection .featured-collection ul .item.sold-out').remove();

  $('.template-search .featured-collection ul .item.sold-out').remove();

  // Pop Up
  $('#popup .cerrar').click(function() {
    $('#popup').removeClass('show');
  });

  if ( winW < 830 ) {
    $('nav ul.menu > li.site-nav--has-dropdown').prepend('<span class="down"><i>+</i></span>');
    $('nav ul.menu > li.submenu51-child').prepend('<span class="down"><i>+</i></span>');
    $('nav ul.menu > li.site-nav--has-dropdown:not(".submenu51-child") span.down').click(function(){
      $(this).toggleClass('active');
      $(this).parent().siblings().children('.sub-menu').removeClass('show');
      $(this).parent().children('.sub-menu').toggleClass('show');
    });
    $('nav ul.menu > li > ul.sub-menu > li.site-nav--has-dropdown').prepend('<span class="down"><i>+</i></span>');
    $('nav ul.menu > li > ul.sub-menu > li.site-nav--has-dropdown:not(".submenu51-child") span.down').on('click', function(){
      $(this).toggleClass('active');
      $(this).parent().siblings().children('.sub-sub-menu').removeClass('show');
      $(this).parent().children('.sub-sub-menu').toggleClass('show');
    });
  }

  // Submenu51
  if (winW > 830) {
    $('.submenu51').appendTo('.header');
    $('.header').mouseleave(function(){
      $('.submenu51').removeClass('show');
    });
    $('.submenu51').mouseleave(function(){
      $('.submenu51').removeClass('show');
    });
    $('.minicart-menu').hover(function(){
      $('.minicart-menu .dropdown-menu').toggle(100);
    });
  } else {
    $('.submenu51 h4 a').removeAttr('href');
    $('.submenu51').appendTo('.expand');
    $('.submenu51').prepend('<span class="back"><svg viewBox="0 0 30 30" aria-labelledby="ahicon--cta-link--arrow-left-desc ahicon--cta-link--arrow-left-title" id="icon--cta-link--arrow-left" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><title id="ahicon--cta-link--arrow-left-title">cta link arrow left</title><desc id="ahicon--cta-link--arrow-left-desc">cta link arrow left</desc><path d="M13.9 9.1l-1.4-1.4c-.4-.4-1-.4-1.4 0L4 14.8c-.4.4-.4 1 0 1.4l1.4 1.4 5.7 5.7c.4.4 1 .4 1.4 0l1.4-1.4c.4-.4.4-1 0-1.4l-4.9-5 4.9-4.9c.4-.5.4-1.1 0-1.5z"></path></svg></span>');
    $('.submenu51 .back').click(function(){
      $('.submenu51').removeClass('show');
      $('.expand .row2').addClass('show');
      $('.expand').removeClass('fix');
      $('.submenu51').scrollTop(0);
    });
    
    $('.menu-div').prepend('<span class="back"><svg viewBox="0 0 30 30" aria-labelledby="ahicon--cta-link--arrow-left-desc ahicon--cta-link--arrow-left-title" id="icon--cta-link--arrow-left" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><title id="ahicon--cta-link--arrow-left-title">cta link arrow left</title><desc id="ahicon--cta-link--arrow-left-desc">cta link arrow left</desc><path d="M13.9 9.1l-1.4-1.4c-.4-.4-1-.4-1.4 0L4 14.8c-.4.4-.4 1 0 1.4l1.4 1.4 5.7 5.7c.4.4 1 .4 1.4 0l1.4-1.4c.4-.4.4-1 0-1.4l-4.9-5 4.9-4.9c.4-.5.4-1.1 0-1.5z"></path></svg></span>');
    $('.menu-div .back').on('click', function() {
      $('.menu-div').removeClass('show');
      $('.menu-div').scrollTop(0);
    });
    
    $('.submenu51 .inner').prepend('<span class="back"><svg viewBox="0 0 30 30" aria-labelledby="ahicon--cta-link--arrow-left-desc ahicon--cta-link--arrow-left-title" id="icon--cta-link--arrow-left" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><title id="ahicon--cta-link--arrow-left-title">cta link arrow left</title><desc id="ahicon--cta-link--arrow-left-desc">cta link arrow left</desc><path d="M13.9 9.1l-1.4-1.4c-.4-.4-1-.4-1.4 0L4 14.8c-.4.4-.4 1 0 1.4l1.4 1.4 5.7 5.7c.4.4 1 .4 1.4 0l1.4-1.4c.4-.4.4-1 0-1.4l-4.9-5 4.9-4.9c.4-.5.4-1.1 0-1.5z"></path></svg></span>');
    $('.submenu51 .inner .back').on('click', function() {
      $('.submenu51 .inner').removeClass('show');
      $('.submenu51 .inner').scrollTop(0);
    });
    
    $('.submenu51 h4').each(function() {
      $(this).click(function(e){
        e.preventDefault();
        var h4title = $(this).next('.menu-div').data('title');
        var h4title2 = $(this).next('.inner').data('title');
        $(this).next('.menu-div').addClass('show');
        $(this).next('.menu-div').prepend('<u>' + h4title + '</u>');
        $(this).next('.inner').addClass('show');
        $(this).next('.inner').prepend('<u>' + h4title2 + '</u>');
      });
    });
    
    $('.expand .cerrar').click(function() {
      $('.submenu51').removeClass('show');
      $('.submenu51 .menu-div').removeClass('show');
      $('.submenu51 .inner').removeClass('show');
      $('.expand .row2').removeClass('show');
      $('.expand').removeClass('show');
      $('.expand .row2').removeClass('show');
      $('.expand').scrollTop(0);
      $('.submenu51').scrollTop(0);
      $('.expand').removeClass('fix');
    });

    $('.minicart-menu').click(function() {
      $('.minicart-menu .dropdown-menu').toggle(100);
    });
  }

  /**
   * Escucha permanente para agregar productos, funciona para snippet
   * product-item.liquid
   *
   * @param object this  Contiene el objeto del elemento cliqueado.
   */
  $('body').on('click', '.item .addcart', function() {
    var proVar = $(this).data('product-id');
    jQuery.ajax({
      type: "POST",
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: proVar
      },
      success: function(data) {
      },
      error: function(data) {
        if (data.status == 422) {
          $('.item-' + proVar + ' .alertas').text('Sin stock disponible');
        }
      },
      async: false
    });
    update_mini_cart(true, true, envio_gratis);
  });
});

/**
 * Escucha permanente para borrar producto del mini carro
 *
 * @param object this  Contiene el objeto del elemento cliqueado.
 */
$('body').on('click', '#minicart .middle .left i.delete-prod', function() {
  var var_this = this;
  Shopify.removeItem($(this).data('id'), function() {
    $(var_this).css("margin", "0").parent().parent().slideUp(200);
    update_mini_cart(false, true, envio_gratis);
  });
});

/**
 * Actualiza el mini carro
 *
 * @param boolean show  Muestra el menu
 * @param boolean all   Actualiza el sector medio del mini carro
 */
function update_mini_cart(show = false, all = true, free = '') {
  if (all) {
    $('#minicart .middle ul').empty();
  }
  $("#minicart .cifra").empty();
  jQuery.get("/cart.js", function(data) {
    for (var i = 0; i < data.items.length; i++) {
      var titulo     = data.items[i]["product_title"];
      var varianteID = data.items[i]["variant_id"];
      var precio     = data.items[i]["line_price"] ? parseFloat(data.items[i]["line_price"]).toString().substring(0, parseFloat(data.items[i]["line_price"]).toString().length - 2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.") : '0';
      var cantidad   = data.items[i]["quantity"];
      var imagen     = data.items[i]["image"];
      var proMini    = "<li><div class='left'><i class='delete-prod' data-id='" + varianteID + "'></i><h4>" + titulo + "</h4><h5>$" + precio + "</h5><h6>Cantidad: <span>" + cantidad + "</span></h6></div><div class='right'><img src='" + imagen + "' alt='' /></div></li>";
      if (all) {
        $("#minicart .middle ul").append(proMini);
      }
    }
    var total1 = data.total_price ? data.total_price.toString().substring(0, data.total_price.toString().length - 2) : '0';
    var total = data.total_price ? data.total_price.toString().substring(0, data.total_price.toString().length - 2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.") : '0';
    var falta1 = free - total1;
    var falta = falta1 ? falta1.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.") : '0';
    var porcentaje = (total1 * 100) / free;
    var itemcount = data.item_count;
    $("#minicart .cifra").append('$' + total);
    $("header .icons li a.cart .count").html(itemcount);
    console.log(falta);
    if (show) {
      $('#minicart').addClass('show');
    }
    if (falta > 0) {
      $(".casi .falta").text('$' + falta);
      $('.casi .aun').show(1);
      $('.casi .listo').hide(1);
      $('.casi .barra .linea2').css('width', porcentaje + '%');
      $('.casi .barra .camion').css('left', porcentaje + '%');
    } else {
      $('.casi .aun').hide(1);
      $('.casi .listo').show(1);
      $('.casi .barra .linea2').css('width', '100%');
      $('.casi .barra .camion').css('left', '100%');
    }
  }, 'json');
}

/**
 * Si en algún momento hay errores de carga de jQuery.
 * Uso: defer(function () { //= acá va la funcion =// });
 *
 * @param object method  Funcion completa a ejecutar
 */
// function defer(method) {
//   if (window.jQuery) {
//     method();
//   } else {
//     setTimeout(function() { defer(method) }, 50);
//   }
// }

// /**
//  * Si en algún momento hay errores de carga de Slick.
//  * Uso: deferSlick(function () { //= acá va la funcion =// });
//  *
//  * @param object method  Funcion completa a ejecutar
//  */
// function deferSlick(method) {
//   let scriptEle = document.createElement("script");
//   scriptEle.setAttribute("src", "https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js");
//   scriptEle.setAttribute("type", "text/javascript");
//   document.body.appendChild(scriptEle);
//   if ((typeof $.fn.slick !== undefined) && (typeof $.fn.slick !== 'undefined')) {
//     method();
//   } else {
//     setTimeout(function() { deferSlick(method) }, 50);
//   }
// }

document.addEventListener("DOMContentLoaded", function() {
  var lazyloadImages;

  if ("IntersectionObserver" in window) {
    lazyloadImages = document.querySelectorAll(".lazy");
    var imageObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var image = entry.target;
          image.classList.remove("lazy");
          imageObserver.unobserve(image);
        }
      });
    });

    lazyloadImages.forEach(function(image) {
      imageObserver.observe(image);
    });
  } else {
    var lazyloadThrottleTimeout;
    lazyloadImages = document.querySelectorAll(".lazy");

    function lazyload () {
      if(lazyloadThrottleTimeout) {
        clearTimeout(lazyloadThrottleTimeout);
      }

      lazyloadThrottleTimeout = setTimeout(function() {
        var scrollTop = window.pageYOffset;
        lazyloadImages.forEach(function(img) {
          if(img.offsetTop < (window.innerHeight + scrollTop)) {
            img.src = img.dataset.src;
            img.classList.remove('lazy');
          }
        });
        if(lazyloadImages.length == 0) {
          document.removeEventListener("scroll", lazyload);
          window.removeEventListener("resize", lazyload);
          window.removeEventListener("orientationChange", lazyload);
        }
      }, 20);
    }

    document.addEventListener("scroll", lazyload);
    window.addEventListener("resize", lazyload);
    window.addEventListener("orientationChange", lazyload);
  }
});